import { Component, ViewChild, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'formly-field-custom-datepicker',
  template: `
    <div class="p-input-icon-right">
      <label for="buttondisplay">{{ to.label }}</label>
      <p-calendar 
        #calendar
        [formControl]="formControl" 
        [formlyAttributes]="field"
        [(ngModel)]="date"
        [showIcon]="true"
        [iconDisplay]="'input'"
        placeholder="Select Dates">
      </p-calendar>
      <div *ngIf="showError" class="formly-validation-message">
        <small class="p-error">{{ errorMessage }}</small>
      </div>
    </div>
  `,
  styles: `
    ::ng-deep .p-highlight {
      color: #D47500;
      background: #FFF1E0;
    }
    .p-error {
       color: #e24c4c;
       font-size: 13px;
       margin-top: 4px;
       font-weight: 500;
    }
  `
})
export class CustomDatepickerTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  @ViewChild('calendar') calendar!: Calendar;
  date!: Date;

  ngOnInit() {
    this.initializeDate();
  }

  private initializeDate() {
    if (this.formControl.value) {
      const dateValue = new Date(this.formControl.value);
      this.date = dateValue;
      this.formControl.setValue(dateValue);
    }
  }

  override get showError(): boolean {
    return this.formControl.invalid && (this.formControl.dirty || this.formControl.touched);
  }

  get errorMessage(): string | null {
    if (this.formControl.hasError('required')) {
      return `${this.to.label || 'This field'} is required`;
    }
    return null;
  }
}
